export function openExternalBrowser(url) {
    const ua = navigator.userAgent || '';
    const isKakao = /KAKAOTALK/i.test(ua);
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);

    // 인앱 브라우저가 아니면 새창
    if (!isKakao) {
        window.open(url, '_blank');
        return;
    }

    // Android: intent로 Chrome을 호출하고 폴백
    if (isAndroid) {
        const path = url.replace(/^https?:\/\//, '');
        const intentUrl = `intent://${path}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`;
        window.location.href = intentUrl;
        setTimeout(() => window.open(url, '_blank'), 600);
        return;
    }

    // iOS: googlechrome 스킴 시도 후 폴백
    if (isIOS) {
        const chromeUrl = url.replace(/^https?:\/\//, 'googlechrome://');
        window.location.href = chromeUrl;
        setTimeout(() => window.open(url, '_blank'), 600);
        return;
    }

    // 기타 폴백
    window.open(url, '_blank');
}